var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationArchery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89893 4.43066C6.01518 6.57754 8.13205 7.96879 10.2058 7.32566C17.9871 4.91441 26.3721 7.65941 30.2871 14.4413C34.2021 21.2231 32.3871 29.8575 26.4077 35.3906C24.8139 36.8644 24.9602 39.3938 26.7602 40.5694",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6552 14.4488C41.1508 13.0069 41.5802 9.06189 41.087 8.20689C40.5939 7.35376 36.962 5.75064 34.4664 7.19251C33.5195 7.74001 33.0639 9.12751 33.6658 10.17C33.9902 10.7306 34.517 11.1188 35.0964 11.2538C35.3795 11.3194 35.537 11.5931 35.4527 11.8706C35.2802 12.4388 35.3552 13.0913 35.6777 13.6538C36.2777 14.6963 37.7083 14.9963 38.6552 14.4488Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8716 32.2013L15.0641 28.05L15.8329 22.7869L10.9279 20.8013L3.73535 24.9544L8.64035 26.94L7.8716 32.2013Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4185 11.4751L15.8247 22.7813",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32471 7.34985V22.3123",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4251 37.0875L12.5063 29.5312",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationArchery);
export default __webpack_public_path__ + "static/media/navigation-archery.80738b78.svg";
export { ForwardRef as ReactComponent };